module.exports = __webpack_public_path__ + "img/face-tongue-money.55bbf0b6.svg";